<template>
  <div :class="$attrs.class">
    <label v-if="label" class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">
      {{ label }}
    </label>
    <input
      v-bind="{ ...$attrs, class: undefined }"
      :value="modelValue"
      :type="type"
      :placeholder="placeholder"
      :step="step"
      :required="required"
      @input="$emit('update:modelValue', $event.target.value)"
      class="w-full bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700
             text-slate-800 dark:text-white placeholder-slate-400 rounded-xl px-4 py-3 text-sm
             focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition"
    />
  </div>
</template>

<script setup>
defineOptions({ inheritAttrs: false })
defineProps({
  modelValue: [String, Number],
  label:       String,
  placeholder: String,
  type:        { type: String, default: 'text' },
  step:        String,
  required:    Boolean,
})
defineEmits(['update:modelValue'])
</script>
